export const RAJ_MARKETING_URL = "https://rajsystem.com/";

/** Routing only; this is never a tenant or authentication trust decision. */
export function isRajMarketingHost(hostname: string = window.location.hostname): boolean {
  const host = hostname.toLowerCase().replace(/\.$/, "");
  return host === "rajsystem.com" || host === "www.rajsystem.com";
}
